import dayjs from 'dayjs'

import { toLocaleString2 } from '../strings'

export const parseFollowupReabAlertData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'general-id': item.id,
      'general-name-total': 0,
      'general-centro': item.lojaId,
      'general-codigo-fornecedor': item.codigoFornecedorProduto,
      'general-codigo-do-produto': item.produtoId,
      'general-nome-do-produto': item.produtoDescricao,
      'general-data-estimada': item.dataPrevistaEntrega,
      'general-a-fornecer': toLocaleString2(item.quantidadeAbastecimento),
      'general-a-fornecer-rs': item.pesoTotal,
      'general-total-pedido': item.valorPedido,
      'general-status-entrega': item.statusPedido,
      'general-status': item.status,
      'general-ruptura-zero': item.rupturaZeroDias ? 'Sim' : 'Não',
      'general-ruptura-ten': item.rupturaDezDias ? 'Sim' : 'Não',
      'general-acao': item.comentario
        ? item.comentario +
          ';' +
          item.dataCriacaoAcompanhamento +
          ';' +
          item.dataSolucaoAcompanhamento
        : '',
      'general-histórico': item.comentario ? 'historico' : '',
      'general-data-faturamento-pedido': item.dataFaturamentoPedido
        ? dayjs(item.dataFaturamentoPedido).format('DD/MM/YYYY')
        : '',
      'general-pedido': item.documentoId,
      'general-data-criacao': item.dataCriacao,
      'general-fornecedor-descricao': item.fornecedorDescricao
    })
  }

  return res
}
